import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 18px;
  height: 18px;
  margin-right: 0.5rem;
`;

const TreeCBEmptyIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
      <g
        data-name="Checkbox"
        fill="#fff"
        stroke="#bdcad2"
        strokeLinejoin="round"
        strokeWidth="2"
        clipPath="url(#a)"
      >
        <rect width="18" height="18" rx="2" stroke="none" />
        <rect x="1" y="1" width="16" height="16" rx="1" fill="none" />
      </g>
    </Svg>
  );
};

export default TreeCBEmptyIcon;
